// See isEmpty function in arrayHelper.ts

/**
 * Returns the difference between two arrays of objects based on a specified key.
 *
 * @param original - The original array of objects.
 * @param modified - The modified array of objects.
 * @param key - The key to compare the objects.
 * @returns The objects in `original` that are not present in `modified`, and the objects in `modified` that are not present in `original`.
 */
export function differenceBy<T extends object>(original: T[], modified: T[], key: keyof T) {
  return original
    .filter(o => !modified.some(m => m[key] === o[key]))
    .concat(modified.filter(m => !original.some(o => o[key] === m[key])))
}

/**
 * Retrieves the value of a nested property from an object based on a specified path.
 *
 * @param entity - The object data that holds the desire property/properties.
 * @param propertyPath - Array of string path using '/' char to navigate through properties/subproperties.
 * @returns The entity value stored in propertyPath.
 */
export function getNestedProperty(entity: any, propertyPaths: string[]) {
  return propertyPaths.map(propertyPath =>
    propertyPath.split('/').reduce((acc, key) => acc && acc[key], entity)
  )
}
